import { useTranslation } from 'react-i18next';

import { Placeholder } from './PlaceHolder';

const MovingGotoPlaceholder = (props: any) => {
  const { t } = useTranslation();

  return (
    <Placeholder
      placeholderText={t('You cannot add Go To Steps to a loop.')}
      {...props}
    />
  );
};

export default MovingGotoPlaceholder;
